<div class="carousel-container" [ngClass]="{'empty-carousel': !isLoading && images.length == 0}">
    <loading class="loading-container" [isLoading]="isLoading"></loading>
    <div *ngIf="!isLoading && images.length > 0" class="images-container" >
        <div class="carousel">
            <img [src]="images[index]" alt="Image" class="carousel-image" (click)="openPopup()" />
        </div>
        <button class="first-button" (click)="prev()"><</button>
        <button class="second-button" (click)="next()">></button>
    
        <!-- Indicadores -->
        <div class="dots-container">
            <span *ngFor="let img of images; let i = index" class="dot" [class.active]="i === index" (click)="selectSlide(i)">
            </span>
        </div>
    </div>

    <div *ngIf="!isLoading && images.length == 0">
        <p></p>
    </div>
</div>

  